import "../../includes/css/template.css";
import "../../includes/assets/5aa1fa4e/css/font-awesome.min.css";
import "../../includes/assets/40b83da1/css/bootstrap.css";
import { getAppId } from "../../utility/Common";

function NavBar() {
    let p = getAppId();
  return (
    <>
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12 module-content2 ">
          <div className="btn-group btn-breadcrumb breadcrumb-primary">
            <a
              href="/"
              className="btn btn-primary visible-lg-block visible-md-block"
              style={{ textDecoration: "none" }}
            >
              <b>
              <i className="fa fa-home" aria-hidden="true"></i> &nbsp; Ukurasa wa Mwanzo
              </b>
            </a>
            <a href="/"
                className="btn btn-primary visible-lg-block visible-md-block"
                style={{ textDecoration: "none" }}
              >
                <b>Nambari ya Ombi: &nbsp;{p?.toUpperCase()}</b>
              </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default NavBar;
